var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { Chart, Geom, Coord, Shape } from 'bizcharts';
import DataSet from '@antv/data-set';
import Debounce from 'lodash-decorators/debounce';
import Bind from 'lodash-decorators/bind';
import classNames from 'classnames';
import autoHeight from '../autoHeight';
import './index.less';
/* eslint no-underscore-dangle: 0 */
/* eslint no-param-reassign: 0 */
const imgUrl = 'https://gw.alipayobjects.com/zos/rmsportal/gWyeGLCdFFRavBGIDzWk.png';
class TagCloud extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            dv: null,
            w: 0,
            h: 0
        };
        this.resize = () => {
            this.requestRef = requestAnimationFrame(() => {
                this.renderChart();
            });
        };
        this.saveRootRef = (node) => {
            this.root = node;
        };
        this.initTagCloud = () => {
            function getTextAttrs(cfg) {
                return Object.assign({}, {
                    fillOpacity: cfg.opacity,
                    fontSize: cfg.origin._origin.size,
                    rotate: cfg.origin._origin.rotate,
                    text: cfg.origin._origin.text,
                    textAlign: 'center',
                    fontFamily: cfg.origin._origin.font,
                    fill: cfg.color,
                    textBaseline: 'Alphabetic',
                }, cfg.style);
            }
            // 给point注册一个词云的shape
            if (Shape.registerShape) {
                Shape.registerShape('point', 'cloud', {
                    drawShape(cfg, container) {
                        const attrs = getTextAttrs(cfg);
                        return container.addShape('text', {
                            attrs: Object.assign(attrs, {
                                x: cfg.x,
                                y: cfg.y,
                            }),
                        });
                    },
                });
            }
        };
    }
    componentDidMount() {
        requestAnimationFrame(() => {
            this.initTagCloud();
            this.renderChart();
        });
        window.addEventListener('resize', this.resize, { passive: true });
    }
    componentDidUpdate(preProps) {
        const { data } = this.props;
        if (JSON.stringify(preProps.data) !== JSON.stringify(data)) {
            this.renderChart(this.props);
        }
    }
    componentWillUnmount() {
        this.isUnmount = true;
        window.cancelAnimationFrame(this.requestRef);
        window.removeEventListener('resize', this.resize);
    }
    renderChart(nextProps) {
        // const colors = ['#1890FF', '#41D9C7', '#2FC25B', '#FACC14', '#9AE65C'];
        const { data, height } = nextProps || this.props;
        if (data.length < 1 || !this.root) {
            return;
        }
        const h = height * 4;
        const w = this.root.offsetWidth * 4;
        const onload = () => {
            const dv = new DataSet.View().source(data);
            const range = dv.range('value');
            const [min, max] = range;
            dv.transform({
                type: 'tag-cloud',
                fields: ['name', 'value'],
                imageMask: this.imageMask,
                font: 'Verdana',
                size: [w, h],
                padding: 5,
                timeInterval: 5000,
                rotate() {
                    return 0;
                },
                fontSize(d) {
                    // eslint-disable-next-line
                    return Math.pow((d.value - min) / (max - min), 2) * (70 - 20) + 20;
                },
            });
            if (this.isUnmount) {
                return;
            }
            this.setState({
                dv,
                w,
                h,
            });
        };
        if (!this.imageMask) {
            this.imageMask = new Image();
            this.imageMask.crossOrigin = '';
            this.imageMask.src = imgUrl;
            this.imageMask.onload = onload;
        }
        else {
            onload();
        }
    }
    render() {
        const { className, height } = this.props;
        const { dv, w, h } = this.state;
        return (React.createElement("div", { className: classNames("tagCloud", className), style: { width: '100%', height }, ref: this.saveRootRef }, dv && (React.createElement(Chart, { width: w, height: h, data: dv, padding: 0, scale: {
                x: { nice: false },
                y: { nice: false },
            } },
            React.createElement(Coord, { reflect: "y" }),
            React.createElement(Geom, { type: "point", position: "x*y", color: "text", shape: "cloud" })))));
    }
}
__decorate([
    Bind(),
    Debounce(500)
], TagCloud.prototype, "renderChart", null);
export default autoHeight()(TagCloud);
